import { useState, useEffect, useRef } from 'react';
import './App.css';
import profileImg from './assets/img/taya.jpeg';

const Ladybug = ({ isFlying, rotation }) => (
  <svg
    width="28"
    height="30"
    viewBox="-6 -1 32 24"
    style={{
      transform: `rotate(${rotation}deg)`,
      transition: isFlying ? 'transform 0.15s' : 'transform 0.5s ease-out',
    }}
  >
    {isFlying && (
      <>
        <ellipse
          cx="0"
          cy="10"
          rx="6"
          ry="3.5"
          fill="rgba(180, 160, 150, 0.5)"
          className="ladybug-wing-left"
        />
        <ellipse
          cx="20"
          cy="10"
          rx="6"
          ry="3.5"
          fill="rgba(180, 160, 150, 0.5)"
          className="ladybug-wing-right"
        />
      </>
    )}
    <ellipse cx="10" cy="12" rx="9" ry="9" fill="#e86a6a" />
    {!isFlying && (
      <line
        x1="10"
        y1="4"
        x2="10"
        y2="20"
        stroke="#333"
        strokeWidth="0.8"
        opacity="0.3"
      />
    )}
    <circle cx="6" cy="10" r="2" fill="#333" />
    <circle cx="14" cy="10" r="2" fill="#333" />
    <circle cx="6.5" cy="16" r="1.5" fill="#333" />
    <circle cx="13.5" cy="16" r="1.5" fill="#333" />
    <circle cx="10" cy="3.5" r="4" fill="#333" />
  </svg>
);

const GitHubIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
  </svg>
);

const LinkedInIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);

const EmailIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M0 3v18h24v-18h-24zm21.518 2l-9.518 7.713-9.518-7.713h19.036zm-19.518 14v-11.817l10 8.104 10-8.104v11.817h-20z" />
  </svg>
);

const ArrowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="7" y1="17" x2="17" y2="7"></line>
    <polyline points="7 7 17 7 17 17"></polyline>
  </svg>
);

const experiences = [
  {
    date: '2023 - 2025',
    title: 'Software Engineer',
    company: 'BeautyShelf',
    description:
      'Built and launched a social media app from the ground up, architecting backend services with AWS and implementing Elasticsearch for content discovery and search. Designed scalable APIs, managed cloud infrastructure with Cloudflare, and developed the React Native mobile client. Released MVP on Google Play.',
    tags: [
      'AWS',
      'Elasticsearch',
      'Cloudflare',
      'React Native',
      'Redux',
      'Expo',
    ],
  },
  {
    date: '2022 - 2023',
    title: 'Software Engineer',
    company: 'American Express',
    description:
      'Built and maintained internal tools and shared technology services used across the enterprise. Developed full-stack features using Java and React, designed REST APIs, and wrote comprehensive unit tests to ensure reliability.',
    tags: ['React', 'Java', 'REST APIs', 'NodeJS'],
  },
  {
    date: 'Sep — Dec 2021',
    title: 'Teaching Fellow',
    company: 'Fullstack Academy',
    description:
      'Managed students’ projects from ideation to deployment as a technical mentor and code reviewer. Taught data structures, algorithms, and system design to a cohort of 60+ junior software engineers.',
    tags: ['JavaScript', 'React', 'Redux', 'NodeJS'],
  },
];

const projects = [
  {
    title: 'PokeWar',
    description:
      'A multiplayer online game where players battle using Pokemon. Features real-time gameplay, user authentication, and a dynamic battle system.',
    image: require('./assets/img/project1.gif'),
    tags: ['React', 'Redux', 'Firebase'],
    github: 'https://github.com/bell-peppers/PokeWar',
    demo: 'https://poke-war-4483c.web.app/',
  },
];

function App() {
  const [activeSection, setActiveSection] = useState('about');

  const [ladybugPos, setLadybugPos] = useState({ x: 150, y: 200 });
  const [ladybugScared, setLadybugScared] = useState(false);
  const [ladybugRotation, setLadybugRotation] = useState(0);
  const ladybugTarget = useRef({ x: 300, y: 300 });
  const mousePos = useRef({ x: -1000, y: -1000 });

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['about', 'experience', 'projects'];
      const scrollPosition = window.scrollY + 200;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (
            scrollPosition >= offsetTop &&
            scrollPosition < offsetTop + offsetHeight
          ) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    let animationId;
    let currentPos = { x: 100, y: 150 };
    let currentRotation = 0;
    let targetRotation = 0;
    let wanderTimer = 0;
    let isCurrentlyFlying = false;
    let flyAwayDirection = { x: 0, y: 0 };

    const getSafeZones = () => {
      const w = window.innerWidth;
      const h = window.innerHeight;
      return [
        { x: 40, y: h * 0.3, weight: 1 },
        { x: 40, y: h * 0.7, weight: 1 },
        { x: w - 40, y: h * 0.3, weight: 1 },
        { x: w - 40, y: h * 0.7, weight: 1 },
        { x: w * 0.45, y: 60, weight: 2 },
        { x: w * 0.45, y: h - 60, weight: 2 },
        { x: w * 0.45, y: h * 0.5, weight: 1 },
        { x: 80, y: 60, weight: 1 },
        { x: w - 80, y: 60, weight: 1 },
        { x: 80, y: h - 60, weight: 1 },
        { x: w - 80, y: h - 60, weight: 1 },
      ];
    };

    const pickNewTarget = () => {
      const zones = getSafeZones();

      const totalWeight = zones.reduce((sum, z) => sum + z.weight, 0);
      let random = Math.random() * totalWeight;
      let chosen = zones[0];
      for (const zone of zones) {
        random -= zone.weight;
        if (random <= 0) {
          chosen = zone;
          break;
        }
      }

      ladybugTarget.current = {
        x: chosen.x + (Math.random() - 0.5) * 60,
        y: chosen.y + (Math.random() - 0.5) * 60,
      };
    };

    pickNewTarget();

    const updateLadybug = () => {
      const mx = mousePos.current.x;
      const my = mousePos.current.y;

      const dx = mx - currentPos.x;
      const dy = my - currentPos.y;
      const distanceToMouse = Math.sqrt(dx * dx + dy * dy);

      const hoverRadius = 30;
      const justStartedFlying =
        !isCurrentlyFlying && distanceToMouse < hoverRadius;

      if (justStartedFlying) {
        const baseAngle = Math.atan2(-dy, -dx);
        const randomOffset = (Math.random() - 0.5) * 0.8;
        flyAwayDirection = {
          x: Math.cos(baseAngle + randomOffset),
          y: Math.sin(baseAngle + randomOffset),
        };
      }

      if (distanceToMouse < hoverRadius) {
        isCurrentlyFlying = true;
      } else if (isCurrentlyFlying && distanceToMouse > 180) {
        isCurrentlyFlying = false;
        pickNewTarget();
      }

      setLadybugScared(isCurrentlyFlying);

      let moveX, moveY;

      if (isCurrentlyFlying) {
        const flySpeed = 2.5;
        moveX = flyAwayDirection.x * flySpeed;
        moveY = flyAwayDirection.y * flySpeed;
      } else {
        const targetDx = ladybugTarget.current.x - currentPos.x;
        const targetDy = ladybugTarget.current.y - currentPos.y;
        const distanceToTarget = Math.sqrt(
          targetDx * targetDx + targetDy * targetDy
        );

        wanderTimer++;
        if (distanceToTarget < 15 || wanderTimer > 800) {
          pickNewTarget();
          wanderTimer = 0;
        }

        const wanderSpeed = 0.2;
        const angle = Math.atan2(targetDy, targetDx);
        moveX = Math.cos(angle) * wanderSpeed;
        moveY = Math.sin(angle) * wanderSpeed;
      }

      currentPos.x += moveX;
      currentPos.y += moveY;

      const padding = 35;
      if (currentPos.x < padding) {
        currentPos.x = padding;
        if (isCurrentlyFlying)
          flyAwayDirection.x = Math.abs(flyAwayDirection.x);
      }
      if (currentPos.x > window.innerWidth - padding) {
        currentPos.x = window.innerWidth - padding;
        if (isCurrentlyFlying)
          flyAwayDirection.x = -Math.abs(flyAwayDirection.x);
      }
      if (currentPos.y < padding) {
        currentPos.y = padding;
        if (isCurrentlyFlying)
          flyAwayDirection.y = Math.abs(flyAwayDirection.y);
      }
      if (currentPos.y > window.innerHeight - padding) {
        currentPos.y = window.innerHeight - padding;
        if (isCurrentlyFlying)
          flyAwayDirection.y = -Math.abs(flyAwayDirection.y);
      }

      if (Math.abs(moveX) > 0.01 || Math.abs(moveY) > 0.01) {
        targetRotation = Math.atan2(moveY, moveX) * (180 / Math.PI) + 90;
      }

      let rotationDiff = targetRotation - currentRotation;
      if (rotationDiff > 180) rotationDiff -= 360;
      if (rotationDiff < -180) rotationDiff += 360;
      currentRotation += rotationDiff * (isCurrentlyFlying ? 0.2 : 0.06);

      setLadybugPos({ x: currentPos.x, y: currentPos.y });
      setLadybugRotation(currentRotation);

      animationId = requestAnimationFrame(updateLadybug);
    };

    const handleMouseMove = (e) => {
      mousePos.current = { x: e.clientX, y: e.clientY };
    };

    window.addEventListener('mousemove', handleMouseMove);
    animationId = requestAnimationFrame(updateLadybug);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      cancelAnimationFrame(animationId);
    };
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="App">
      <div className="floating-leaves-css">
        <div className="floating-leaf-css leaf-1"></div>
        <div className="floating-leaf-css leaf-2"></div>
        <div className="floating-leaf-css leaf-3"></div>
        <div className="floating-leaf-css leaf-4"></div>
        <div className="floating-leaf-css leaf-5"></div>
        <div className="floating-leaf-css leaf-6"></div>
        <div className="floating-leaf-css leaf-7"></div>
        <div className="floating-leaf-css leaf-8"></div>
        <div className="floating-leaf-css blossom-1"></div>
        <div className="floating-leaf-css blossom-2"></div>
        <div className="floating-leaf-css blossom-3"></div>
      </div>

      <div
        className={`ladybug ${ladybugScared ? 'scared' : ''}`}
        style={{
          left: ladybugPos.x,
          top: ladybugPos.y,
        }}
      >
        <Ladybug isFlying={ladybugScared} rotation={ladybugRotation} />
      </div>

      <div className="layout">
        <header className="sidebar">
          <div className="sidebar-content">
            <div className="profile-wrapper">
              <img src={profileImg} alt="Taya Ugay" className="profile-img" />
            </div>
            <h1>Taya Ugay</h1>
            <h2>Software Engineer</h2>
            <p className="sidebar-intro">
              Creating digital experiences that bloom with purpose.
            </p>

            <nav className="nav-links">
              <button
                className={`nav-link ${
                  activeSection === 'about' ? 'active' : ''
                }`}
                onClick={() => scrollToSection('about')}
              >
                About
              </button>
              <button
                className={`nav-link ${
                  activeSection === 'experience' ? 'active' : ''
                }`}
                onClick={() => scrollToSection('experience')}
              >
                Experience
              </button>
              <button
                className={`nav-link ${
                  activeSection === 'projects' ? 'active' : ''
                }`}
                onClick={() => scrollToSection('projects')}
              >
                Projects
              </button>
            </nav>
          </div>

          <div className="social-links">
            <a
              href="https://github.com/hitaya1"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              aria-label="GitHub"
            >
              <GitHubIcon />
            </a>
            <a
              href="https://www.linkedin.com/in/taya-ugay/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              aria-label="LinkedIn"
            >
              <LinkedInIcon />
            </a>
            <a
              href="mailto:taissiya.ugay@gmail.com"
              className="social-link"
              aria-label="Email"
            >
              <EmailIcon />
            </a>
          </div>
        </header>

        <main className="main-content">
          <section id="about">
            <h2 className="section-header">About</h2>
            <div className="about-content">
              <p>
                Hello! I'm a developer who believes that beautiful things can
                also be powerful. My journey into programming started with a
                spark of curiosity and has{' '}
                <span className="highlight">blossomed into a passion</span> for
                creating digital experiences that feel alive and meaningful.
              </p>
              <p>
                I'm driven by{' '}
                <span className="highlight">growth and possibility</span> —
                constantly learning, evolving, and pushing myself to create work
                that matters.
              </p>
            </div>
          </section>

          <section id="experience">
            <h2 className="section-header">Experience</h2>
            <div className="experience-list">
              {experiences.map((exp, index) => (
                <div key={index} className="experience-item">
                  <div className="experience-date">{exp.date}</div>
                  <div className="experience-content">
                    <h3>
                      <span className="experience-title">
                        {exp.title} ·{' '}
                        <span className="experience-company">
                          {exp.company}
                        </span>
                      </span>
                    </h3>
                    <p className="experience-description">{exp.description}</p>
                    <div className="experience-tags">
                      {exp.tags.map((tag, tagIndex) => (
                        <span key={tagIndex} className="tag">
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section id="projects">
            <h2 className="section-header">Projects</h2>
            <div className="projects-list">
              {projects.map((project, index) => (
                <a
                  key={index}
                  href={project.demo || project.github}
                  className="project-item"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="project-image">
                    {project.image ? (
                      <img src={project.image} alt={project.title} />
                    ) : (
                      <div
                        style={{
                          width: '100%',
                          height: '100%',
                          background: 'var(--card-bg)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '0.75rem',
                          color: 'var(--text-secondary)',
                        }}
                      >
                        Preview
                      </div>
                    )}
                  </div>
                  <div className="project-content">
                    <h3>
                      <span className="project-title">{project.title}</span>
                      <span className="project-arrow">
                        <ArrowIcon />
                      </span>
                    </h3>
                    <p className="project-description">{project.description}</p>
                    <div className="project-tags">
                      {project.tags.map((tag, tagIndex) => (
                        <span key={tagIndex} className="tag">
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </section>

          <footer className="footer">
            <p>
              Designed with{' '}
              <span
                style={{
                  color: '#e8b4b8',
                  fontStyle: 'normal',
                  fontSize: '1.1em',
                  textShadow: '0 0 1px #e8b4b8',
                }}
              >
                ♥
              </span>
              , built with{' '}
              <a
                href="https://reactjs.org/"
                target="_blank"
                rel="noopener noreferrer"
              >
                React
              </a>
              . Always growing, always blooming.
            </p>
          </footer>
        </main>
      </div>
    </div>
  );
}

export default App;
